export default {
  gradePremium: {
    id: 'grade_premium',
    defaultMessage: 'Premium',
  },
  gradeShiny: {
    id: 'grade_shiny',
    defaultMessage: 'Mint',
  },
  gradeGold: {
    id: 'grade_gold',
    defaultMessage: 'Very good',
  },
  gradeSilver: {
    id: 'grade_silver',
    defaultMessage: 'Good',
  },
  gradeBronze: {
    id: 'grade_bronze',
    defaultMessage: 'Fair',
  },
  gradeStallone: {
    id: 'grade_stallone',
    defaultMessage: 'Stallone',
  },
  grade: {
    id: 'listings_offer_grade',
    defaultMessage: 'Aesthetic grade: {grade, html}',
  },
  simType: {
    id: 'bo-seller.listings.sim-type',
    defaultMessage: 'SIM: {simType, html}',
  },
  listingSKU: {
    id: 'listings_offer_sku_v2',
    defaultMessage: 'SKU: {sku}',
  },
  archiveListing: {
    id: 'listings_offer_archive',
    defaultMessage: 'Archive listing',
  },
  publishListing: {
    id: 'listings_offer_publish',
    defaultMessage: 'Publish listing',
  },
  stock: {
    id: 'listings_stock',
    defaultMessage: 'Stock',
  },
  formLabel: {
    id: 'listings_update_form',
    defaultMessage: 'Update listing form',
  },
  price: {
    id: 'listings_price_country',
    defaultMessage: '{country} Price ({currency})',
  },
  minimumPriceSetBeforeTargetPriceError: {
    id: 'listings_minimum_price_set_before_target_price_error',
    defaultMessage: 'The target price must be set before the minimum price',
  },
  minimumPriceBelowTargetPriceError: {
    id: 'listings_minimum_price_error',
    defaultMessage: 'The minimum price must be below the target price',
  },
  minimumPrice: {
    id: 'listings_min_price_country',
    defaultMessage: '{country} min. Price ({currency})',
  },
  targetPrice: {
    id: 'listings_target_price_country',
    defaultMessage: '{country} target Price ({currency})',
  },
  save: {
    id: 'listings_save',
    defaultMessage: 'Save',
  },
  backboxPrice: {
    id: 'listings_backbox_price_country',
    defaultMessage: '{country} Backbox Price',
  },
  hasNoBackbox: {
    id: 'listings_warning_you_dont_have_the_buybox',
    defaultMessage: "You don't have the Buybox",
  },
  errorToastLimitationTitle: {
    id: 'listings_error_toast_limitation_title',
    defaultMessage: 'Too many request!',
  },
  errorToastGenericTitle: {
    id: 'listings_error_toast_generic_title',
    defaultMessage: 'Oops!',
  },
  errorToastLimitationContent: {
    id: 'listings_error_toast_limitation_content',
    defaultMessage: "You've reached your limit of updates per hour",
  },
  errorToastGenericContent: {
    id: 'listings_error_toast_generic_content',
    defaultMessage: 'Sorry, something went wrong...',
  },
  newBattery: {
    id: 'listings-listing-special_offer-new_battery',
    defaultMessage: 'New battery',
  },
  withBackbox: {
    id: 'listings_with_buybox',
    defaultMessage: 'With Buybox',
  },
  withoutBackbox: {
    id: 'listings_without_buybox',
    defaultMessage: 'Without Buybox',
  },
}
